'use client';

import { __makeTemplateObject } from '../_virtual/_tslib.js';
import React__default from 'react';
import styled from 'styled-components';

var StyledParagraph = styled.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 0px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: ", ";\n"], ["\n    margin: 0px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: ", ";\n"])), function (props) { var _a; return (_a = props.lines) !== null && _a !== void 0 ? _a : 1; });
var LineClampText = function (_a) {
    var lines = _a.lines, content = _a.content;
    return (React__default.createElement("div", null,
        React__default.createElement(StyledParagraph, { lines: lines }, content)));
};
var templateObject_1;

export { LineClampText as default };
//# sourceMappingURL=LineClampText.js.map
